import { Button } from "@shared/ui";
import { FileSpreadsheet, UserPlus } from "lucide-react";
import React from "react";
import styles from "./creatorFitFlow.module.scss";

export interface CreatorFitSelectionFooterProps {
  selectedCount: number;
  onClear: () => void;
  onExportExcel: () => void;
  onSuggestCampaign: () => void;
}

export function CreatorFitSelectionFooter({
  selectedCount,
  onClear,
  onExportExcel,
  onSuggestCampaign,
}: CreatorFitSelectionFooterProps) {
  if (selectedCount === 0) return null;

  return (
    <div className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.countBlock}>
          <span className={styles.selectedBadge}>
            {selectedCount} selected
          </span>
          <button type="button" className={styles.clearBtn} onClick={onClear}>
            Deselect all
          </button>
        </div>
        <div className={styles.footerActions}>
          <Button
            icon={<FileSpreadsheet size={14} />}
            onClick={onExportExcel}
          >
            Export as Excel
          </Button>
          <Button
            type="primary"
            icon={<UserPlus size={14} />}
            onClick={onSuggestCampaign}
          >
            Suggest in campaign
          </Button>
        </div>
      </div>
    </div>
  );
}
